import { useSyncExternalStore } from "react";

import type { ActiveEditSession } from "./editSession.ts";
import {
  getLiveEditPreviewForObject,
  subscribeLiveEditPreview,
} from "./liveEditPreview.ts";

function subscribeNoop(): () => void {
  return () => {};
}

export function useLiveEditPreview(
  objectId: string | null | undefined,
): ActiveEditSession | null {
  return useSyncExternalStore(
    objectId ? subscribeLiveEditPreview : subscribeNoop,
    () => getLiveEditPreviewForObject(objectId),
    () => null,
  );
}

export function useResolvedLiveEditGeometry(
  objectId: string | null | undefined,
  vertices: Float32Array,
  dirtyVertices?: Uint32Array | null,
): {
  vertices: Float32Array;
  dirtyVertices: Uint32Array | null;
  dirtyVertexPositions: Float32Array | null;
} {
  const liveEditPreview = useLiveEditPreview(objectId);
  const sparse = liveEditPreview?.vertexPatch ?? null;
  return {
    vertices: liveEditPreview?.vertices ?? vertices,
    dirtyVertices:
      liveEditPreview?.dirtyVertices ??
      sparse?.indices ??
      dirtyVertices ??
      null,
    dirtyVertexPositions: sparse?.positions ?? null,
  };
}
